import useAsync from '@composables/useAsync.js'
import { getSSOInfoRequest } from '@services'
import { readonly, ref } from 'vue'

const ssoInfoState = ref({})

export default function () {
  const {
    loading: loadingSSOInfo,
    error: errorSSOInfo,
    data: dataSSOInfo,
    run: runSSOInfo,
  } = useAsync(getSSOInfoRequest)

  async function getSSOInfo(game) {
    if (game?.sso_mapping && !ssoInfoState.value[game.id]) {
      await runSSOInfo(game.id)

      if (!errorSSOInfo.value) {
        setSSOInfo(game.id, dataSSOInfo.value)
      }
    }
  }

  function setSSOInfo(gameId, info) {
    ssoInfoState.value[gameId] = {
      ...info,
    }
  }

  return {
    ssoInfo: readonly(ssoInfoState),
    loading: loadingSSOInfo,
    setSSOInfo,
    getSSOInfo,
  }
}
